<template>
  <div class="big orderSettlement">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>

    <div class="page_title">订单结算监测</div>
    <div style="padding: 20px; border-radius: 5px">
      <div
        class="container"
        style="padding: 10px 20px 20px 20px;"
      >

        <el-row
          :gutter="20"
          class="search-box"
        >

          <!-- 处方号 -->
          <el-col :span="6">
            <div class="item">
              <span>处方号</span>
              <div class="item-content">
                <el-input
                  v-model="orderForm.pre_id"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="处方号"
                ></el-input>
              </div>
            </div>
          </el-col>

          <!-- 订单号 -->
          <el-col :span="6">
            <div class="item">
              <span>订单号</span>
              <div class="item-content">
                <el-input
                  v-model="orderForm.order_sn"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="订单号"
                ></el-input>
              </div>
            </div>
          </el-col>

          <!-- 医生姓名 -->
          <el-col :span="6">
            <div class="item">
              <span>医生姓名</span>
              <div class="item-content">
                <el-input
                  v-model="orderForm.doctor_name"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="医生"
                ></el-input>
              </div>
            </div>
          </el-col>

          <!-- 患者姓名 -->
          <el-col :span="6">
            <div class="item">
              <span>患者姓名</span>
              <div class="item-content">
                <el-input
                  v-model="orderForm.user_name"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="患者"
                ></el-input>
              </div>
            </div>
          </el-col>

          <!-- 支付日期 -->
          <el-col :span="8">
            <div class="item">
              <span>支付日期</span>
              <div class="item-content">
                <el-date-picker
                  v-model="orderForm.pay_time"
                  size="small"
                  type="daterange"
                  align="right"
                  unlink-panels
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="getList"
                >
                </el-date-picker>
              </div>
            </div>
          </el-col>

          <!-- 发货日期 -->
          <el-col
            :span="7"
            style="margin-right:20px"
          >
            <div class="item">
              <span>发货日期</span>
              <div class="item-content">
                <el-date-picker
                  v-model="orderForm.send_time"
                  size="small"
                  type="daterange"
                  align="right"
                  unlink-panels
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="getList"
                >
                </el-date-picker>
              </div>
            </div>
          </el-col>

          <!-- 完成日期 -->
          <el-col
            :span="7"
            style="margin-right:60px"
          >
            <div class="item">
              <span>完成日期</span>
              <div class="item-content">
                <el-date-picker
                  v-model="orderForm.completion_time"
                  size="small"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="getList"
                >
                </el-date-picker>
              </div>
            </div>
          </el-col>

          <!-- 结算日期 -->
          <el-col :span="8">
            <div class="item">
              <span>结算日期</span>
              <div class="item-content">
                <el-date-picker
                  v-model="orderForm.sa_time"
                  size="small"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="getList"
                >
                </el-date-picker>
              </div>

            </div>
          </el-col>

          <!-- 结算状态 -->
          <el-col :span="6">
            <div class="item">
              <span>结算状态</span>
              <div
                class="item-content"
                style="width:58%"
              >
                <el-select
                  v-model="orderForm.doc_settlement"
                  size="small"
                  clearable
                  @change="getList"
                  placeholder="结算状态"
                >
                  <el-option
                    label="未结算"
                    :value="0"
                  ></el-option>
                  <el-option
                    label="已结算"
                    :value="1"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </el-col>

          <!-- 订单异常 -->
          <el-col :span="6">
            <div class="item">
              <span>订单异常</span>
              <div class="item-content">
                <el-radio-group
                  v-model="orderForm.is_abnormal"
                  style="width: 210px;margin-right:20px;"
                >
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </div>
              <el-button
                type="primary"
                size="small"
                @click="getList"
              >查询</el-button>
              <el-button
                size="small"
                @click="restBtn"
              >重置</el-button>
            </div>
          </el-col>

        </el-row>

        <!-- 信息 -->
        <div class="infoTip-box">
          <div
            class="warning"
            style="color:#F56C6C"
          >异常标准：已结算的订单结算金额不等于应结算的/完成时间后36小时未结算的</div>
          <div class="total-info">
            <p>共 <el-link type="primary">{{ totalInfo.total_order }}</el-link> 订单,</p>
            <p>已结算 <el-link type="primary">{{ totalInfo.total_sett_order }}</el-link> 订单,</p>
            <p>未结算 <el-link type="primary">{{ totalInfo.total_nosett_order }}</el-link> 订单,</p>
            <p>应结算金额:<el-link type="primary">{{ totalInfo.total_price }}</el-link>,</p>
            <p>已结算金额:<el-link type="primary">{{ totalInfo.total_sett_price }}</el-link>,</p>
            <p>未结算金额:<el-link type="primary">{{ totalInfo.total_nosett_price }}</el-link>
            </p>
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table
            v-loading="tableLoading"
            :data="orderData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :align="item.align"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div
                  v-else-if="item.prop == 'doctor_name'"
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer"
                >
                  {{ scope.row.doctor_name}}
                </div>
                <div v-else-if="item.prop == 'send_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'completion_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'doc_settlement'">
                  {{ scope.row[item.prop] | settlementText }}
                </div>
                <div v-else-if="item.prop == 'sa_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled=" module_id_array[0] ? !module_id_array.includes('115') : false"
                  @click="toDetail(scope.row)"
                >订单详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum>0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import systemWarning from '@/api/systemWarning.js';
import Pagination from '@/components/Pagination/index';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  components: {
    Pagination,
    DocMsg
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      orderForm: {
        pre_id: '',
        order_sn: '',
        doctor_name: '',
        user_name: '',
        doc_settlement: '',
        is_abnormal: 1,
        pay_time: [],
        send_time: [],
        completion_time: [],
        sa_time: []
      },
      totalInfo: {},
      tableHeader: [
        {
          label: '处方号',
          prop: 'pre_id',
          width: 'auto',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '订单号',
          prop: 'order_sn',
          width: '160',
          align: 'center',
          fixed: false
        },
        {
          label: '医生姓名',
          prop: 'doctor_name',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '患者姓名',
          prop: 'user_name',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '支付时间',
          prop: 'create_time',
          width: '140',
          align: 'center',
          fixed: false
        },
        {
          label: '发货时间',
          prop: 'send_time',
          width: '140',
          align: 'center',
          fixed: false
        },
        {
          label: '揽收时间',
          prop: 'hospital_name',
          width: '140',
          align: 'center',
          fixed: false
        },
        {
          label: '诊后管理费',
          prop: 'consult_drug_price',
          width: '100',
          align: 'center',
          fixed: false
        },
        {
          label: '诊金',
          prop: 'consulting_gold',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '订单金额',
          prop: 'pay_money',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '完成时间',
          prop: 'completion_time',
          width: '140',
          align: 'center',
          fixed: false
        },
        {
          label: '结算状态',
          prop: 'doc_settlement',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '结算时间',
          prop: 'sa_time',
          width: '140',
          align: 'center',
          fixed: false
        },
        {
          label: '结算金额',
          prop: 'js_price',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      orderData: [],
      doc_msg: false,
      doctorId: ''
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    settlementText(val) {
      switch (val) {
        case 0:
          return '未结算';
        case 1:
          return '已结算';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.initCompletionTime();
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    initCompletionTime() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format('YYYY-MM-DD');
      start = dayjs(start).format('YYYY-MM-DD');
      this.orderForm.completion_time = [start, end];
      console.log(this.orderForm.completion_time);
    },
    getList() {
      let params = Object.assign(this.pagination, this.orderForm);
      params = _.omit(params, [
        'pay_time',
        'sa_time',
        'send_time',
        'completion_time'
      ]);
      let pay_time = this.orderForm.pay_time;
      let send_time = this.orderForm.send_time;
      let completion_time = this.orderForm.completion_time;
      let sa_time = this.orderForm.sa_time;
      params['pay_time_start'] = pay_time ? pay_time[0] : '';
      params['pay_time_end'] = pay_time ? pay_time[1] : '';
      params['send_time_start'] = send_time ? send_time[0] : '';
      params['send_time_end'] = send_time ? send_time[1] : '';
      params['completion_time_start'] = completion_time
        ? completion_time[0]
        : '';
      params['completion_time_end'] = completion_time ? completion_time[1] : '';
      params['sa_time_start'] = sa_time ? sa_time[0] : '';
      params['sa_time_end'] = sa_time ? sa_time[1] : '';
      this.tableLoading = true;
      systemWarning.orderSettlementMonitor(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          if (this.pagination.page === 1) {
            this.totalInfo = _.omit(data, [
              'currentPage',
              'list',
              'pageNumber',
              'total',
              'totalPage'
            ]);
          }
          this.orderData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    toDetail(row) {
      this.$router.push({
        path: '/home/order/orderdetail',
        query: {
          order_id: row.order_id
        }
      });
    },
    restBtn() {
      for (let key in this.orderForm) {
        this.orderForm[key] = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.orderSettlement {
  .search-box {
    display: flex;
    // justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      // width: 23%;
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 60px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
      }
    }
    .item-content {
      width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .infoTip-box {
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    .warning {
      display: flex;
      align-items: center;
      white-space: nowrap;
    }
    .total-info {
      display: flex;
      align-items: center;
      white-space: nowrap;
      .el-link {
        font-size: 16px;
      }
    }
  }
}
</style>